/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccesoDenegado as AccesoDenegado,
  rec_CA as CA,
  rec_Componente_TA_84_65 as Componente_TA_84_65,
  rec_EstadoError as EstadoError,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_Modal as Modal,
  rec_React as React,
  rec_Ro as Ro,
  rec_SA as SA,
  rec_SelectorMultiple as SelectorMultiple,
  rec_api as api,
  rec_puedeRutaAdmin as puedeRutaAdmin,
  rec_ii as ii,
  rec_ji as ji,
  rec_kr as kr,
  rec_obtenerUsuario as obtenerUsuario,
  rec_pS as pS,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function ErroresSistema() {
  let e = puedeRutaAdmin(`/admin/errores`),
    t = Go(),
    [n, r] = (0, React.useState)(`pendientes`),
    [i, a] = (0, React.useState)(``),
    [o, s] = (0, React.useState)([]),
    [c, l] = (0, React.useState)(!0),
    [u, f] = (0, React.useState)(``),
    [p, m] = (0, React.useState)(null),
    h = (0, React.useCallback)(async () => {
      l(!0);
      try {
        (s(await api(`/errores?estado=${n}${i ? `&origen=${i}` : ``}`)), f(``));
      } catch (e) {
        f(e.message);
      } finally {
        l(!1);
      }
    }, [n, i]);
  if (
    ((0, React.useEffect)(() => {
      h();
    }, [h]),
    !e)
  )
    return <AccesoDenegado />;
  async function g(e) {
    try {
      m(await api(`/errores/${e.id}`));
    } catch (e) {
      t.error(e.message);
    }
  }
  async function _(e, n) {
    try {
      (await api(`/errores/${e.id}/resolver`, {
        method: `POST`,
        body: JSON.stringify({
          resuelto: n,
          actorNombre: obtenerUsuario()?.nombre,
        }),
      }),
        m(null),
        t.ok(n ? `Marcado como resuelto` : `Vuelve a la lista`),
        h());
    } catch (e) {
      t.error(e.message);
    }
  }
  return (
    <EstructuraPrincipal
      title={`Errores del sistema`}
      children={[
        <div
          className={`flex flex-col gap-4`}
          children={[
            <div
              className={`flex flex-wrap items-center justify-between gap-2`}
              children={[
                <p
                  className={`text-sm text-(--text)`}
                  children={`Cada línea es un problema distinto, con las veces que pasó. Se atiende de arriba hacia abajo.`}
                />,
                <div
                  className={`flex flex-wrap items-center gap-2`}
                  children={[
                    <div
                      className={`w-44`}
                      children={
                        <SelectorMultiple
                          value={n}
                          onChange={(e) => r(e || `pendientes`)}
                          opciones={SA}
                          placeholder={`Sin resolver`}
                        />
                      }
                    />,
                    <div
                      className={`w-44`}
                      children={
                        <SelectorMultiple
                          value={i}
                          onChange={a}
                          placeholder={`De todas partes`}
                          opciones={Object.entries(CA).map(([e, t]) => ({
                            value: e,
                            label: t,
                          }))}
                        />
                      }
                    />,
                  ]}
                />,
              ]}
            />,
            u && <EstadoError mensaje={u} onReintentar={h} />,
            c &&
              (0, JSXRuntime.jsx)(ii, {
                className: `h-5 w-5 animate-spin text-(--text)`,
              }),
            !c && !u && o.length === 0 && (
              <p
                className={`rounded-2xl border border-(--border) bg-(--bg) p-4 text-sm text-(--text)`}
                children={
                  n === `resueltos`
                    ? `Todavía no hay nada marcado como resuelto.`
                    : `No hay errores registrados. Buena señal.`
                }
              />
            ),
            o.length > 0 && (
              <ul
                className={`flex flex-col gap-1.5`}
                children={o.map((e) => (
                  <li
                    key={e.id}
                    children={
                      <button
                        type={`button`}
                        onClick={() => g(e)}
                        className={`rounded-2xl border border-(--border) bg-(--bg) p-4 flex w-full flex-col gap-1 text-left transition hover:border-(--accent-border)`}
                        children={[
                          <div
                            className={`flex flex-wrap items-center gap-2`}
                            children={[
                              <span
                                className={`rounded-full border border-(--error-border) bg-transparent px-2 py-0.5 text-[11px] text-(--error)`}
                                children={[
                                  e.veces,
                                  ` `,
                                  e.veces === 1 ? `vez` : `veces`,
                                ]}
                              />,
                              <span
                                className={`min-w-0 flex-1 truncate text-sm font-medium text-(--text-h)`}
                                children={e.mensaje || e.tipo}
                              />,
                              e.resuelto && (
                                <span
                                  className={`rounded-full border border-(--success-border) px-2 py-0.5 text-[11px] text-(--success)`}
                                  children={`Resuelto`}
                                />
                              ),
                            ]}
                          />,
                          <p
                            className={`truncate text-xs text-(--text)`}
                            children={[
                              CA[e.origen] ?? e.origen,
                              e.ruta && (
                                <JSXRuntime.Fragment
                                  children={[
                                    ` · `,
                                    e.metodo ? `${e.metodo} ` : ``,
                                    e.ruta,
                                  ]}
                                />
                              ),
                              e.usuarioNombre && (
                                <JSXRuntime.Fragment
                                  children={[` · le pasó a `, e.usuarioNombre]}
                                />
                              ),
                              e.ultimaVez && (
                                <JSXRuntime.Fragment
                                  children={[` · última vez `, pS(e.ultimaVez)]}
                                />
                              ),
                            ]}
                          />,
                        ]}
                      />
                    }
                  />
                ))}
              />
            ),
          ]}
        />,
        p && (
          <Modal
            titulo={`Detalle del error`}
            onClose={() => m(null)}
            ancho={`max-w-3xl`}
            children={
              <div
                className={`flex flex-col gap-3 text-sm`}
                children={[
                  <p
                    className={`font-medium text-(--text-h)`}
                    children={p.mensaje || p.tipo}
                  />,
                  <dl
                    className={`grid gap-x-4 gap-y-2 sm:grid-cols-2`}
                    children={[
                      <Componente_TA_84_65 titulo={`Tipo`} valor={p.tipo} />,
                      <Componente_TA_84_65
                        titulo={`Dónde`}
                        valor={`${p.metodo ? p.metodo + ` ` : ``}${p.ruta || `—`}`}
                      />,
                      <Componente_TA_84_65
                        titulo={`Veces`}
                        valor={String(p.veces)}
                      />,
                      <Componente_TA_84_65
                        titulo={`Respuesta`}
                        valor={p.estadoHttp ? String(p.estadoHttp) : `—`}
                      />,
                      <Componente_TA_84_65
                        titulo={`Primera vez`}
                        valor={pS(p.primeraVez)}
                      />,
                      <Componente_TA_84_65
                        titulo={`Última vez`}
                        valor={pS(p.ultimaVez)}
                      />,
                      <Componente_TA_84_65
                        titulo={`Le pasó a`}
                        valor={p.usuarioNombre || `—`}
                      />,
                      <Componente_TA_84_65
                        titulo={`Origen`}
                        valor={CA[p.origen] ?? p.origen}
                      />,
                    ]}
                  />,
                  p.traza && (
                    <pre
                      className={`max-h-80 overflow-auto rounded-2xl bg-(--code-bg) p-3 text-[11px] leading-relaxed text-(--text)`}
                      children={p.traza}
                    />
                  ),
                  <div
                    className={`flex flex-col-reverse gap-2 border-t border-(--border) pt-3 sm:flex-row sm:justify-end`}
                    children={[
                      <button
                        type={`button`}
                        onClick={() => m(null)}
                        className={zo}
                        children={`Cerrar`}
                      />,
                      p.resuelto ? (
                        <button
                          type={`button`}
                          onClick={() => _(p, !1)}
                          className={zo}
                          children={[
                            (0, JSXRuntime.jsx)(ji, {
                              className: `mr-1 inline h-4 w-4`,
                            }),
                            ` Volver a abrirlo`,
                          ]}
                        />
                      ) : (
                        <button
                          type={`button`}
                          onClick={() => _(p, !0)}
                          className={Ro}
                          children={[
                            (0, JSXRuntime.jsx)(kr, {
                              className: `mr-1 inline h-4 w-4`,
                            }),
                            ` Marcar como resuelto`,
                          ]}
                        />
                      ),
                    ]}
                  />,
                ]}
              />
            }
          />
        ),
      ]}
    />
  );
}
